import * as React from 'react';
import { Label } from '../Label';
import { Toggle } from '../Toggle';
import { cn } from '../../lib/utils';
import type { ToggleWithLabelProps } from './types';

function ToggleWithLabel({
  label,
  className,
  id,
  ...props
}: ToggleWithLabelProps) {
  const generatedId = React.useId();

  const toggleId = id ?? generatedId;
  const labelId = `${toggleId}-label`;
  const labelNamesToggle = !props['aria-label'];
  const ariaLabelledBy = labelNamesToggle
    ? [props['aria-labelledby'], labelId].filter(Boolean).join(' ')
    : props['aria-labelledby'];

  return (
    <div
      className={cn('eye:inline-flex eye:items-center eye:gap-2xs', className)}
    >
      <Toggle {...props} id={toggleId} aria-labelledby={ariaLabelledBy} />
      <Label
        id={labelId}
        htmlFor={toggleId}
        aria-hidden={labelNamesToggle || undefined}
      >
        {label}
      </Label>
    </div>
  );
}

export { ToggleWithLabel };
